import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CardMedia, Dialog, DialogTitle, DialogActions, Button, DialogContent, Grid, Fab } from '@material-ui/core';
import { IoChevronForwardOutline as ForwardIcon, IoChevronBackOutline as BackIcon } from 'react-icons/io5';
import theme from 'assets';

interface IMediaThumb {
    fileId: string
    fileIds: string[]
    extension: string
    width: number
    height: number
    isImage: boolean
    isReadOnly?: boolean
}

const useStyles = makeStyles(() => ({
    card: {
        color: 'transparent',
        '&:hover': {
            boxShadow: ' 0 7px 20px rgba(0,0,0,0.15), 0 8px 10px rgba(0,0,0,0.2), 0 6px 3px -4px rgba(0,0,0,0.15)'
        }
    },
    navigationFab: {
        position: 'fixed',
        top: '50%'
    },
    navigationFabWrapper: {
        width: 56 + theme.spacing(2)
    }
}));

let MediaThumb = (props: IMediaThumb) => {
    let classes = useStyles();

    let [cardSrc, setCardSrc] = useState<string>('');
    let [showPreview, setShowPreview] = useState<boolean>(false);

    let [dialogSrc, setDialogSrc] = useState<string>('');
    let [idToShow, setIdToShow] = useState<string>('');

    let handleKeyDown = (eventKey: string) => {
        switch (eventKey) {
            case 'ArrowRight':
                updateDialogSrc('forward')
                break;

            case 'ArrowLeft':
                updateDialogSrc('backward')
                break;

            case 'Escape':
                setShowPreview(false);
                break;

            default:
                break;
        }
    };

    useEffect(() => {
        let prepareData = () => {
            setIdToShow(props.fileId);
            if (props.isImage) {
                if (props.fileId !== '' && props.fileId !== 'placeholder') {
                    setCardSrc(`/api/TicketMessage/GetAttachment?id=${props.fileId}`);
                    setDialogSrc(`/api/TicketMessage/GetAttachment?id=${props.fileId}`);
                } else {
                    setCardSrc('/images/placeholder.png');
                    setDialogSrc('/images/placeholder.png');
                }
            } else {
                setCardSrc(`/images/fileTypes/${props.extension.toLowerCase()}.svg`);
            }
        }

        prepareData();
    }, [props.fileId, props.fileIds, props.extension, props.width, props.height, props.isImage]);


    let updateDialogSrc = (action: 'backward' | 'forward') => {
        let currentIx: number = props.fileIds.findIndex(f => f === idToShow);

        let updatedIx: number = 0;

        if (currentIx >= 0) {
            updatedIx = action === 'forward' ? currentIx + 1 : currentIx - 1;

            if (updatedIx < 0)
                updatedIx = props.fileIds.length - 1;

            if (updatedIx >= props.fileIds.length)
                updatedIx = 0;
        }

        let updatedIdToShow: string = props.fileIds[updatedIx];

        setIdToShow(updatedIdToShow);
        setDialogSrc(`/api/TicketMessage/GetAttachment?id=${updatedIdToShow}`);
    }

    return (
        <>
            <CardMedia
                className={props.isReadOnly === true ? undefined : classes.card}
                image={cardSrc}
                component="img"
                onClick={() => props.isReadOnly === true ? undefined : setShowPreview(true)}
                style={{
                    cursor: props.isReadOnly === true ? 'initial' : 'pointer',
                    minWidth: props.width,
                    minHeight: props.height,
                    maxWidth: props.width
                }}
            />

            <Dialog
                open={showPreview}
                maxWidth="lg"
                fullWidth={true}
                scroll="paper"
                onClose={() => setShowPreview(false)}
                onKeyDown={(ev) => handleKeyDown(ev.key)}
            >
                <DialogTitle />

                <DialogContent>
                    <Grid container justifyContent='center' alignItems="center">
                        {props.fileIds.length > 1 &&
                            <Grid item className={classes.navigationFabWrapper}>
                                <Fab
                                    className={classes.navigationFab}
                                    onClick={() => updateDialogSrc('backward')}>
                                    <BackIcon size={24} />
                                </Fab>
                            </Grid>
                        }
                        <Grid item xs>
                            <CardMedia
                                image={dialogSrc}
                                component="img"
                                style={{ margin: 'auto' }}
                            />
                        </Grid>
                        {props.fileIds.length > 1 &&
                            <Grid item className={classes.navigationFabWrapper}>
                                <Fab
                                    className={classes.navigationFab}
                                    onClick={() => updateDialogSrc('forward')}
                                >
                                    <ForwardIcon size={24} />
                                </Fab>
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setShowPreview(false)}
                        color="secondary"
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default MediaThumb;